import { render, staticRenderFns } from "./SetNewPassword.vue?vue&type=template&id=a07fee36&scoped=true&"
import script from "./SetNewPassword.vue?vue&type=script&lang=js&"
export * from "./SetNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./SetNewPassword.vue?vue&type=style&index=0&id=a07fee36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07fee36",
  null
  
)

export default component.exports